import directives from '../module';
import { Utils } from 'underscore-extensions';

class LandingPage {
    videoOptions = {
        volume: 0
    };

    videoId = '5e8c762646e0fb002b800a12';

    private static readonly animationActiveClz = 'stager--active';

    readonly tabs = ['startup', 'teachers', 'animators', 'everyone'];

    tabChange() {
        const selectors = '.tabs-animated-content, .quote-wrapper';
        const all: Array<HTMLElement> = [].slice.call(
            document.querySelectorAll(selectors)
        );
        all.forEach(el => el.classList.remove(LandingPage.animationActiveClz));
        setTimeout(() =>
            Utils.rAF(() =>
                all.forEach(el =>
                    el.classList.add(LandingPage.animationActiveClz)
                )
            )
        );
    }
}

directives.component('landingPage', {
    controller: LandingPage,
    templateUrl: require('landing/landing-new.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/landing/LandingPage.ts